<section class="intro px-8">
  <h2 class="text-2xl mt-8">
    Produkty
  </h2>
  <p class="mt-8">
    Nasze pojemniki do lad chłodniczych i pojemniki GN wykonane są z następujących tworzyw:
  </p>
  <ul class="mt-8 mb-8 list-disc pl-10">
    <li>ABS</li>
    <li>PC</li>
    <li>melamina</li>
    <li>akryl</li>
  </ul>
  <p class="mt-8">
    Kolory dostępne w ofercie to: czarny, biały, żółty, zielony, niebieski. Wszystkie pojemniki mają atesty dopuszczające je do kontaktu z żywnością.
  </p>
</section>